"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendario = void 0;
var bson_1 = require("bson");
var Calendario = /** @class */ (function () {
    function Calendario(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.CD_CALENDARIO, CD_CALENDARIO = _c === void 0 ? '' : _c, _d = _a.CENTRO, CENTRO = _d === void 0 ? '' : _d, _e = _a.DT_VAL_INI, DT_VAL_INI = _e === void 0 ? '' : _e, _f = _a.DT_VAL_FIM, DT_VAL_FIM = _f === void 0 ? '' : _f, _g = _a.LINK_CAL, LINK_CAL = _g === void 0 ? '' : _g, _h = _a.DIAS_UTEIS, DIAS_UTEIS = _h === void 0 ? 0 : _h;
        this._id = _id;
        this.CD_CALENDARIO = CD_CALENDARIO;
        this.CENTRO = CENTRO;
        this.DT_VAL_INI = DT_VAL_INI;
        this.DT_VAL_FIM = DT_VAL_FIM;
        this.LINK_CAL = LINK_CAL;
        this.DIAS_UTEIS = DIAS_UTEIS;
    }
    return Calendario;
}());
exports.Calendario = Calendario;
//# sourceMappingURL=Calendario.js.map